/**
 * The window text written into crfPackage/visitMapping for a visit.
 *
 * Only the visit's OWN window/timing text is stored. A "Day N" label is never
 * derived from `day` here: the mapping is a frozen copy and went stale when the
 * schedule was corrected. Readers (the CRF Completion Guide) overlay the live
 * timing from studyDesign/config; old documents that carry `window` still read.
 * Returns undefined when there is none, so callers omit the field.
 */
export function ownWindowText(v: { window?: unknown; timing?: unknown; day?: unknown }): string | undefined {
  for (const t of [v.window, v.timing]) {
    if (typeof t === 'string' && t.trim()) return t.trim();
  }
  return undefined;
}
